<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('exams.Header') }}</h2>

            </div>
        </div>
        <div id="image_holder" class="imageHolder" style="height:auto; display:flex">
            <div class="fotos_treeview">
                <kendo-treeview ref="treeView"
                                id="treeView"
                                :data-source="remoteDataSource"
                                @select="onFotoCategoryChanged"
                                :data-text-field="'Titel'"
                                style="overflow: auto">
                </kendo-treeview>
            </div>
            <div class="fotos_flux">
                <vue-flux :options="vfOptions"
                          :images="vfImages"
                          :transitions="vfTransitions">
                    <template v-slot:preloader>
                        <flux-preloader />
                    </template>
                    <template v-slot:index>
                        <flux-index />
                    </template>
                    <template v-slot:controls>
                        <flux-controls />
                    </template>
                </vue-flux>
            </div>
        </div>

        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';
    import {
        TreeView
    } from "@progress/kendo-treeview-vue-wrapper";
    import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
    import {
        VueFlux,
        FluxCaption,
        FluxControls,
        FluxIndex,
        FluxPagination,
        FluxPreloader,
    } from 'vue-flux';
    import kendo from '@progress/kendo-ui';
    import 'viewerjs/dist/viewer.css';
    import VueViewer from 'v-viewer';
    import Vue from 'vue';
    import axios from 'axios';
    import $ from 'jquery';
    import "@progress/kendo-ui";
    import config from "@/appdata/config.json";

    Vue.use(VueViewer);

    export default {
        components: {
            'kendo-treeview': TreeView,
            'datasource': DataSource,
            VueFlux,
            FluxCaption,
            FluxControls,
            FluxIndex,
            FluxPagination,
            FluxPreloader,
        },
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
                vfOptions: {
                    autoplay: true,
                    allowFullscreen: true,
                    aspectRatio: '4:3'
                },
                vfImages: [],
                vfTransitions: ['blinds3d', 'blocks2', 'wave'],
                remoteDataSource: new kendo.data.HierarchicalDataSource({
                    requestEnd: this.onRequestEnd,
                    transport: {
                        read: {
                            url: config[0].ServiceUrl + config[0].ServiceUrlPort + "/FotosGruppe?RefFotosGruppe=4",
                            dataType: 'json'
                        }
                    },
                    schema: {
                        model: {
                            id: 'Prim',
                            children: 'Items'
                        }
                    }
                })

            }

        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
            onRequestEnd() {
                const treeview = this.$refs.treeView.kendoWidget();
                setTimeout(() => {
                    treeview.expand("li:first");
                    treeview.select($($("#treeView > li:first").find("li.k-item")[0]));
                    treeview.trigger("select", {
                        node: $($("#treeView > li:first").find("li.k-item")[0]),
                    });
                });
            },
            onFotoCategoryChanged(e) {
                this.vfImages = [];
                const dataItem = e.sender.dataItem(e.node);

                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/FotosPfade', {
                    params: {
                        RefFotoAlbum: dataItem.Prim
                    }
                })
                    .then((response) => {
                        response.data.forEach(d => {
                            const image = config[0].BaseUrl + d;
                            this.vfImages.push(image);
                        });
                    }
                    )
                    .catch(error => console.log("------------> error", error)
                    )
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>